import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackingService } from '../services/tracking';

/**
 * Composant qui initialise le tracking et track les changements de page
 */
export default function TrackingInitializer() {
  const location = useLocation();

  useEffect(() => {
    // Initialiser le tracking des clics une seule fois
    trackingService.initClickTracking();
  }, []);

  useEffect(() => {
    // Tracker chaque changement de page
    trackingService.trackPageView(location.pathname);
  }, [location.pathname]);

  return null; // Ce composant ne rend rien
}

